import { render, staticRenderFns } from "./TagUserView.vue?vue&type=template&id=5f43c0ec&scoped=true"
import script from "./TagUserView.vue?vue&type=script&lang=js"
export * from "./TagUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f43c0ec",
  null
  
)

export default component.exports